import './CIPopup.css';
import './LARPopup.css'
import {Modal, Button} from 'react-bootstrap';

const CIPopup = (props) => {
    return(
        <div>
            <Modal show={true} onHide={false} backdrop='static'>
                <Modal.Header>
                    <Modal.Title style={{fontSize:'1rem'}}>Once you delete these items, you won't be able to retrieve them later. Are you sure you want to delete them?</Modal.Title>
                </Modal.Header>

                <Modal.Footer style={{display:'flex', justifyContent:'center'}}>
                    <button className='btn green_button' onClick={props.handleDeleteAfterConfirmation}>Yes</button>
                    <button className='btn red_button' onClick={props.handleClose}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default CIPopup